import { render, staticRenderFns } from "./EventExpenseSetup.vue?vue&type=template&id=08bc2b41&scoped=true"
import script from "./EventExpenseSetup.vue?vue&type=script&lang=ts"
export * from "./EventExpenseSetup.vue?vue&type=script&lang=ts"
import style0 from "./EventExpenseSetup.vue?vue&type=style&index=0&id=08bc2b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc2b41",
  null
  
)

export default component.exports